var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTripadvisor = function SvgTripadvisor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "tripadvisor_svg__Layer_2",
    width: 70,
    height: 70,
    fill: "#050505",
    viewBox: "0 -70 512.2 512.2"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tripadvisor_svg__SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", null, ".tripadvisor_svg__st0{fill:#0a0a0a}"), /*#__PURE__*/React.createElement("path", {
    d: "M128.2 127.9C92.7 127.9 64 156.6 64 192s28.7 64.1 64.1 64.1 64.1-28.7 64.1-64.1c.1-35.4-28.6-64.1-64-64.1m0 110c-25.3 0-45.9-20.5-45.9-45.9s20.5-45.9 45.9-45.9S174 166.7 174 192s-20.5 45.9-45.8 45.9",
    className: "tripadvisor_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.4,
    cy: 191.9,
    r: 31.9,
    className: "tripadvisor_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.2 127.9c-35.4 0-64.1 28.7-64.1 64.1s28.7 64.1 64.1 64.1 64.1-28.7 64.1-64.1-28.7-64.1-64.1-64.1m0 110c-25.3 0-45.9-20.5-45.9-45.9s20.5-45.9 45.9-45.9S430 166.7 430 192s-20.5 45.9-45.8 45.9",
    className: "tripadvisor_svg__st0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384.4,
    cy: 191.9,
    r: 31.9,
    className: "tripadvisor_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m474.4 101.2 37.7-37.4h-76.4C392.9 29 321.8 0 255.9 0c-66 0-136.5 29-179.3 63.8H0l37.7 37.4C14.4 124.4 0 156.5 0 192c0 70.8 57.4 128.2 128.2 128.2 32.5 0 62.2-12.1 84.8-32.1l43.4 31.9 42.9-31.2-.5-1.2c22.7 20.2 52.5 32.5 85.3 32.5 70.8 0 128.2-57.4 128.2-128.2-.1-35.4-14.6-67.5-37.9-90.7M368 64.8c-60.7 7.6-108.3 57.6-111.9 119.5-3.7-62-51.4-112.1-112.3-119.5 30.6-22 69.6-32.8 112.1-32.8S337.4 42.8 368 64.8M128.2 288.2C75 288.2 32 245.1 32 192s43.1-96.2 96.2-96.2 96.2 43.1 96.2 96.2c-.1 53.1-43.1 96.2-96.2 96.2m256 0c-53.1 0-96.2-43.1-96.2-96.2s43.1-96.2 96.2-96.2 96.2 43.1 96.2 96.2c-.1 53.1-43.1 96.2-96.2 96.2",
    className: "tripadvisor_svg__st0"
  }))));
};
export default SvgTripadvisor;